"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationValidationSchema = void 0;
const zod_1 = require("zod");
const countries = __importStar(require("i18n-iso-countries"));
exports.LocationValidationSchema = zod_1.z
    .object({
    countryCode: zod_1.z.string().refine((value) => {
        if (typeof value === 'undefined') {
            return true;
        }
        if (typeof value === 'string' && Object.keys(countries.getAlpha3Codes()).includes(value))
            return true;
        return false;
    }),
    city: zod_1.z.string(),
    postalCode: zod_1.z.string(),
    address: zod_1.z.string(),
    staircase: zod_1.z.number().nullable(),
    floor: zod_1.z.number().nullable(),
    door: zod_1.z.string(),
    coordinates: zod_1.z.object({
        lat: zod_1.z.number().nullable(),
        lng: zod_1.z.number().nullable(),
    }),
})
    .partial();
//# sourceMappingURL=location.js.map